import { render, staticRenderFns } from "./AvailabilityRegionRideTypeForm.vue?vue&type=template&id=b190ec10&"
import script from "./AvailabilityRegionRideTypeForm.vue?vue&type=script&lang=js&"
export * from "./AvailabilityRegionRideTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilityRegionRideTypeForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports